<template>
  <v-app>
    <div class="login-page">
      <!-- Snackbar -->
      <v-snackbar
        v-model="snackbar.visible"
        :color="snackbar.color"
        :timeout="snackbar.timeout"
        :top="snackbar.position === 'top'"
      >
        <v-layout align-center pr-4>
          <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
          <v-layout column>
            <div><strong>{{ snackbar.title }}</strong></div>
            <div>{{ snackbar.text }}</div>
          </v-layout>
        </v-layout>
        <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-snackbar>

      <!-- Ambient glow -->
      <div class="login-glow login-glow--a"></div>
      <div class="login-glow login-glow--b"></div>

      <div class="login-shell">
        <v-row no-gutters align="stretch" justify="center" class="login-row">
          <!-- Hero (desktop) -->
          <v-col v-if="$vuetify.breakpoint.mdAndUp" cols="12" md="7" class="pr-md-8">
            <div class="hero-card">
              <img :src="currentSlide" alt="" class="hero-img" />
              <div class="hero-scrim"></div>
              <div class="hero-content">
                <span class="hero-eyebrow">Word of the Day</span>
                <p class="hero-quote">
                  “No one in this world is famous solely because of the talent they have,
                  but by working they can turn talent into something genius.”
                </p>
                <span class="hero-author">— Anna Pavlova</span>
              </div>
              <div class="hero-dots">
                <span
                  v-for="(s, i) in slides"
                  :key="i"
                  class="hero-dot"
                  :class="{ 'hero-dot--active': i === currentSlideIndex }"
                ></span>
              </div>
            </div>
          </v-col>

          <!-- Login form -->
          <v-col cols="12" md="5">
            <div class="login-card">
              <div class="text-center">
                <div class="brand-avatar">
                  <v-icon size="46" color="white">mdi-account</v-icon>
                </div>
                <h1 class="brand-title">SATU<span>KPI</span></h1>
                <p class="brand-sub">Silakan masuk untuk melanjutkan</p>
              </div>

              <v-form class="mt-6" @submit.prevent="login">
                <div class="field-label">Username</div>
                <v-text-field
                  v-model="username"
                  placeholder="Masukkan username"
                  outlined
                  dense
                  prepend-inner-icon="mdi-account-outline"
                  required
                />
                <div class="field-label">Password</div>
                <v-text-field
                  v-model="password"
                  placeholder="Masukkan password"
                  :type="showPassword ? 'text' : 'password'"
                  outlined
                  dense
                  prepend-inner-icon="mdi-lock-outline"
                  :append-icon="showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                  @click:append="showPassword = !showPassword"
                  required
                />
                <v-btn
                  color="primary"
                  block
                  x-large
                  depressed
                  class="login-btn mt-2"
                  type="submit"
                >
                  <v-icon left>mdi-login-variant</v-icon>
                  Masuk
                </v-btn>
              </v-form>
            </div>
          </v-col>
        </v-row>

        <footer class="login-footer">
          <span class="footer-line"></span>
          <span class="footer-logo">
            <img src="@/assets/LogoJ99.png" alt="J99 Corp" />
          </span>
          <span class="footer-copy">© {{ currentYear }} SATU-KPI · All rights reserved</span>
        </footer>
      </div>
    </div>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      snackbar: {
        color: null,
        icon: null,
        mode: null,
        position: "top",
        text: null,
        timeout: 7500,
        title: null,
        visible: false,
      },
      slides: [
        require("@/assets/oke.jpg"),
        require("@/assets/oke2.jpg"),
        require("@/assets/oke3.jpg"),
      ],
      currentSlideIndex: 0,
      currentSlide: require("@/assets/oke.jpg"),
      username: "",
      password: "",
      showPassword: false,
      currentYear: new Date().getFullYear(),
    };
  },
  mounted() {
    setInterval(() => {
      this.currentSlideIndex = (this.currentSlideIndex + 1) % this.slides.length;
      this.currentSlide = this.slides[this.currentSlideIndex];
    }, 3000);
  },
  methods: {
    login() {
      this.$store
        .dispatch("loginUser", {
          email: this.username,
          password: this.password,
        })
        .then((response) => {
          const user = this.$store.getters.getUser;
          const menus = this.$store.getters.getMenus;
          const firstActiveRoute = this.findFirstActiveRoute(menus);

          this.snackbar = {
            visible: true,
            color: "success",
            icon: "mdi-check-circle",
            title: "Login Berhasil",
            text: `Status: ${response.status} — Anda berhasil login`,
            timeout: 4000,
            position: "top",
          };
          if (user.is_password_changed === 0) {
            this.$router.push("/changepassword");
          } else if (firstActiveRoute) {
            this.$router.push(firstActiveRoute);
          } else {
            alert("Akun ini tidak memiliki akses menu aktif.");
          }
        })
        .catch((error) => {
          const fallbackMsg = "Terjadi kesalahan saat login.";
          const errorMsg =
            error.response?.data?.errors?.email?.[0] ||
            error.response?.data?.message ||
            fallbackMsg;
          this.snackbar = {
            visible: true,
            color: "error",
            icon: "mdi-alert-circle",
            title: "Login Gagal !",
            text: errorMsg,
            timeout: 5000,
            position: "top",
          };
        });
    },
    findFirstActiveRoute(menus) {
      for (const menu of menus) {
        if (menu.is_active === 1 && menu.route) return menu.route;
        if (menu.children && Array.isArray(menu.children)) {
          const child = menu.children.find((c) => c.is_active === 1 && c.route);
          if (child) return child.route;
        }
      }
      return null;
    },
  },
};
</script>

<style scoped>
.login-page {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  background:
    radial-gradient(1200px 600px at 15% 10%, #315977 0%, rgba(49, 89, 119, 0) 55%),
    radial-gradient(900px 500px at 95% 90%, #1f4460 0%, rgba(31, 68, 96, 0) 60%),
    linear-gradient(135deg, #24455f 0%, #16304a 55%, #0f2740 100%);
}

/* Ambient blobs */
.login-glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(90px);
  opacity: 0.35;
  pointer-events: none;
}
.login-glow--a {
  width: 420px;
  height: 420px;
  top: -120px;
  left: -80px;
  background: #4fd1c5;
}
.login-glow--b {
  width: 380px;
  height: 380px;
  bottom: -140px;
  right: -60px;
  background: #2f80ed;
}

.login-shell {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 1040px;
}
.login-row {
  animation: rise 0.6s cubic-bezier(0.22, 1, 0.36, 1) both;
}
@keyframes rise {
  from { opacity: 0; transform: translateY(16px); }
  to { opacity: 1; transform: translateY(0); }
}

/* ===== Hero ===== */
.hero-card {
  position: relative;
  height: 100%;
  min-height: 480px;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 30px 60px -25px rgba(0, 0, 0, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.12);
}
.hero-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: opacity 0.6s ease, transform 6s ease;
  transform: scale(1.05);
}
.hero-scrim {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(15, 39, 64, 0) 35%,
    rgba(15, 39, 64, 0.55) 70%,
    rgba(15, 39, 64, 0.92) 100%
  );
}
.hero-content {
  position: absolute;
  left: 32px;
  right: 32px;
  bottom: 34px;
  color: #fff;
}
.hero-eyebrow {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #7fe9dd;
  margin-bottom: 12px;
}
.hero-quote {
  font-size: 1.15rem;
  line-height: 1.55;
  font-style: italic;
  font-weight: 300;
  margin-bottom: 10px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}
.hero-author {
  font-weight: 700;
  font-size: 0.95rem;
  opacity: 0.9;
}
.hero-dots {
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  gap: 7px;
}
.hero-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.45);
  transition: all 0.3s ease;
}
.hero-dot--active {
  width: 22px;
  border-radius: 4px;
  background: #7fe9dd;
}

/* ===== Login card ===== */
.login-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #fff;
  border-radius: 24px;
  padding: 40px 36px;
  box-shadow: 0 30px 60px -25px rgba(0, 0, 0, 0.5);
}
.brand-avatar {
  width: 84px;
  height: 84px;
  margin: 0 auto 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #2f80ed 0%, #16304a 100%);
  box-shadow: 0 12px 26px -10px rgba(47, 128, 237, 0.7);
  border: 3px solid #fff;
  outline: 1px solid rgba(0, 0, 0, 0.06);
}
.brand-title {
  font-size: 1.9rem;
  font-weight: 800;
  letter-spacing: 1px;
  color: #16304a;
  line-height: 1;
}
.brand-title span {
  color: #2f80ed;
}
.brand-sub {
  margin-top: 6px;
  margin-bottom: 0;
  font-size: 0.9rem;
  color: #90a4ae;
}
.field-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #37474f;
  margin-bottom: 6px;
}

/* Netralkan background & bayangan autofill browser */
.login-card ::v-deep input:-webkit-autofill,
.login-card ::v-deep input:-webkit-autofill:hover,
.login-card ::v-deep input:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
  box-shadow: 0 0 0 1000px #fff inset !important;
  -webkit-text-fill-color: #16304a !important;
  caret-color: #16304a;
  transition: background-color 9999s ease-in-out 0s;
}
.login-btn {
  border-radius: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: none;
  box-shadow: 0 12px 24px -10px rgba(47, 128, 237, 0.7) !important;
}

/* ===== Footer ===== */
.login-footer {
  position: relative;
  z-index: 1;
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}
.footer-line {
  width: 90px;
  height: 1px;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.35),
    rgba(255, 255, 255, 0)
  );
}
.footer-logo img {
  height: 26px;
  width: auto;
  display: block;
  /* Ubah logo (merah + charcoal) jadi flat putih agar menyatu di latar navy */
  filter: brightness(0) invert(1);
  opacity: 0.85;
  transition: opacity 0.3s ease;
}
.footer-logo:hover img {
  opacity: 1;
}
.footer-copy {
  font-size: 0.74rem;
  letter-spacing: 0.4px;
  color: rgba(255, 255, 255, 0.55);
}

@media (max-width: 600px) {
  .login-page {
    padding: 24px 14px;
    align-items: center;
  }
  .login-card {
    padding: 28px 20px;
    border-radius: 20px;
  }
  .brand-title {
    font-size: 1.6rem;
  }
}
</style>
